import { IconNames } from '@vk-hr-tek/ui/Icon';

import { Collection } from '@app/gen/event-type';

export const COLLECTIONS_ICONS: Record<Collection['type'], IconNames> = {
  vacations: 'calendar_outline',
  absences: 'alarm_outline',
  business_trips: 'plane_outline',
  papers: 'document_text_outline',
  review: 'folder_simple_user_outline',
  competencies: 'document_stats_outline',
  personal: 'user_outline',
  payslips: 'wallet_outline',
  work_arrangement: 'repeat_outline',
  another: 'folder_outline',
};
